import { REGIE } from '@/configuration/societe/societe';
import store from '@/store/store';
import { cloneDeep } from 'lodash';

export default function setFournisseurIfNotRegie(produit, nouvelleLigneCommande) {
  const societeActive = store.getters['societe/societeActive'];

  if (societeActive.roleParDefaut === REGIE || !nouvelleLigneCommande.lignesCommande) return;

  nouvelleLigneCommande.lignesCommande.forEach((ligneEnfant) => {
    ligneEnfant.fournisseurId = cloneDeep(produit.tiersId);
    ligneEnfant.fournisseur = cloneDeep(produit.tiers);
  });
}
